import React from 'react';
import {Select} from 'antd';
import {uiMessage} from './uiText';

// Candidates are database-validated, version-pinned queries returned by the server.
export default function IntentResolution({result,onSelect}) {
    const resolution=result.resolution,candidates=resolution?.candidates || [];
    const key=query=>JSON.stringify([query.datasetVersion,query.unitId]);
    const reasons={context:'The current disease unit matches this query.',unique:'One disease unit matches this query.',explicit:'The requested disease unit matches this query.',most_complete:`Matched ${candidates.length} disease units. Selected the unit with the most complete matching pair, variant and carrier records.`};
    return <div className="rgnet-intent-resolution">
        <p>{uiMessage(resolution?.reason,reasons[resolution?.method] || "Select a matched gene.",result.messageLocale)}</p>
        {candidates.length>1&&<div className="rgnet-intent-unit-switch">
            <label htmlFor="rgnet-intent-unit">Matched disease unit</label>
            <Select id="rgnet-intent-unit" aria-label={"Matched disease unit"} showSearch optionFilterProp="label"
                value={key(result.query)} onChange={value=>{const candidate=candidates.find(row=>key(row.query)===value);if(candidate)onSelect(candidate.query);}}
                options={candidates.map(row=>({value:key(row.query),label:row.query.name || "Disease name not supplied"}))} />
        </div>}
    </div>;
}
